import styles from './FileTree.module.scss';
import Text from '../Text/TextComponent';
import { dataResources } from '@portal-internet/core';
import { ReactSVG } from 'react-svg';
import { useGetFileTreeUrl } from '../../utils/hooks/useGetFileTreeUrl';
import { getData } from '@portal-internet/bff';
import { useQuery } from 'react-query';
import { useState, useEffect } from 'react';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

export default function FileTreeComponent({ pathname, title, userId }) {
    const {
        showRightSidePanel,
        setShowRightSidePanel,
        setFileTree,
        fileTree,
        fileTreeLocalStorageName,
        FILE_TREE_CACHE_EXPIRE_TIME
    } = useRedl();
    const [open, setOpen] = useState(false);
    const getFileTreeUrl = useGetFileTreeUrl();
    const { data } = useQuery(['fileTreeRoot', { url: getFileTreeUrl(pathname) }], getData, {
        staleTime: Infinity
    });

    const lastOpen = fileTree?.lastOpenPath;

    const changeRightSidePanel = () => {
        setShowRightSidePanel((prevState) => ({
            ...prevState,
            size: 'lg',
            action: 'add',
            data: { ...data, breadcrumbs: [...title, data?.summary?.title] }
        }));
    };

    useEffect(() => {
        let aux = true;
        if (data?.content) {
            aux = data.content === 'index';
        }

        if (Array.isArray(fileTree?.openedPaths)) {
            const filteredPaths = fileTree.openedPaths.filter((path) => path.startsWith(pathname));
            for (const path of filteredPaths) {
                if ((pathname != path || aux) && !open) {
                    setOpen(true);
                    break;
                }
            }
        }

        if (pathname === fileTree?.lastOpenPath && data?.content === 'modules') {
            changeRightSidePanel();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const togglePath = (paths = []) => {
        const index = paths.indexOf(pathname);
        if (index !== -1) {
            paths = paths.filter((path) => !path.startsWith(pathname));
        } else if (data.content === 'index') {
            paths.push(pathname);
        }
        return paths;
    };

    const savePath = (isLastOpen = true) => {
        const now = new Date();
        const data = {
            openedPaths: togglePath(fileTree?.openedPaths),
            lastOpenPath: isLastOpen ? pathname : fileTree.lastOpenPath,
            expire: now.getTime() + FILE_TREE_CACHE_EXPIRE_TIME
        };
        setFileTree(data);
        localStorage.setItem(fileTreeLocalStorageName, JSON.stringify(data));
    };

    const onToggle = (event) => {
        if (data.content === 'modules') {
            changeRightSidePanel();
            savePath();
        } else {
            setOpen((prevState) => !prevState);
            savePath(false);
        }
        event.preventDefault();
    };

    const isActive = data?.content === 'modules' && showRightSidePanel.data?.summary?.pathname === pathname;

    if (!data) return null;

    return (
        <li className={styles.redlFileTreeItemLi}>
            <details open={open}>
                <summary
                    className={`${styles.redlFileTreeItemSummary} ${isActive ? styles.redlFileTreeItemSummaryActive : ''}`}
                    onClick={onToggle}
                    data-testid={`REDL-file-tree-summary-${data?.summary?.title?.replace(/\s+/g, '_')}`}
                >
                    <div className={styles.redlFileTreeIcon}>
                        <ReactSVG
                            className={styles.redlFileTreeIconClosed}
                            src={basePath + '/_resources/REDL/icons/folder.svg?v=JIT_ENV_RESOURCES_VERSION'}
                        />
                        <ReactSVG
                            className={styles.redlFileTreeIconOpen}
                            src={basePath + '/_resources/REDL/icons/folder2-open.svg?v=JIT_ENV_RESOURCES_VERSION'}
                        />
                    </div>
                    <Text tag='span' size='md' weight='400'>
                        {data?.summary?.title}
                    </Text>
                </summary>
                <ul>
                    {open &&
                        data?.essence?.map((e) => (
                            <FileTreeComponent
                                key={e.pathname}
                                pathname={e.pathname}
                                title={[...title, data?.summary?.title]}
                                userId={userId}
                            />
                        ))}
                </ul>
            </details>
        </li>
    );
}
